import { render, staticRenderFns } from "./DailyChallenge.vue?vue&type=template&id=c16c8a20&"
import script from "./DailyChallenge.vue?vue&type=script&lang=ts&"
export * from "./DailyChallenge.vue?vue&type=script&lang=ts&"
import style0 from "./DailyChallenge.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports